import { Pipe, PipeTransform } from '@angular/core';
/**
 * Trim pipe
 */
@Pipe({
  name: 'trim'
})
export class TrimPipe implements PipeTransform {
  /**
   * trims the value
   * @param value value to be trimmed
   * @param args additional args
   */
  transform(value: unknown, ...args: unknown[]): unknown {
    return value?.toString().trim();
  }
}
